import {Card, CardHeader, CardBody} from "components/ui";
import style from "./Tegel.module.scss";
import React from "react";
import TagAantal from "../../TagAantal/TagAantal";
import Image from 'next/image';
import LocalizedLinkClient from "../../LocalizedLink/LocalizedLinkClient";

export default function Tegel(props){


    const header = <CardHeader className={style.cardHeader}>
        {props.tag && <TagAantal aantal={props.tag}/>}
        {props.imageurl && <Image
            src={props.imageurl}
            width={20}
            height={46}
            alt="Tile icon"
        />}
        {props.icon && props.icon}
        {props.titel && props.titel}
    </CardHeader>


    const body = <CardBody>
        <ul style={{ listStyle: "none", paddingLeft: 0, marginLeft: '-40px' }} >
            {Array.isArray(props.tekst) ? props.tekst.map((x, i) => {
                return <li key={i} className={!props.arrow && style.noListStyle}>{x}</li>
            }) : <li key={Math.random()} className={!props.arrow && style.noListStyle}>{props.tekst}</li>
            }
        </ul>
    </CardBody>


    if (props.url === null || props.isDisabled) {
        const classes = [style.tegel];
        if (props.isDisabled) classes.push(style.isDisabled);
        else classes.push(style.notClickable);

        return (
            <Card className={classes.join(" ")}>
                {header}
                {body}
            </Card>
        );
    }


    let link = '';
    if (props.openNewWindow) {
        link = <a href={props.url} target="_blank">
            {header}
            {body}
        </a>
    } else {
        link = <LocalizedLinkClient
            href={props.url}
            name={props.titel}
        >
            {header}
            {!props.noBody && body}
        </LocalizedLinkClient>
    }


    return   <Card className={style.tegel}>
        {link}
    </Card>
}